// src/components/ModularB2B.js
import React from 'react';
import './ModularB2B.css';

function ModularB2B() {
  return (
    <div className="modular-container">
      <header className="modular-header">
        <h1>Modular B2B Subscription Solutions</h1>
      </header>
      <section className="modular-content">
        <h2>Accelerate Your Business with Ready-to-Use AI Agents</h2>
        <p>
          Welcome to our <strong>Modular B2B Subscription</strong> offering, where simplicity and efficiency converge to bring you powerful, pre-configured AI agents at an accessible price point. This solution is designed for businesses that need a quick, cost-effective way to integrate AI into their existing workflows—without the overhead of bespoke development.
        </p>
        <h3>Why Choose Our Modular AI Agents?</h3>
        <ol>
          <li>
            <strong>Instant Deployment:</strong> Our ready-made AI agents are fully optimized for immediate use. After subscribing, you can integrate an agent into your operational environment right away, drastically cutting down on your time-to-market.
          </li>
          <li>
            <strong>Cost-Effective Subscription Model:</strong> Pay a flat monthly or annual fee to access an agent tailored to your industry or use-case. This predictable pricing keeps operational costs transparent and manageable, ideal for businesses of all sizes.
          </li>
          <li>
            <strong>Broad Selection of Industry-Focused Agents:</strong> From e-commerce product recommendation bots to real estate lead-generation assistants, we offer a diverse library of AI agents. Each agent is built on cutting-edge Large Language Models (LLMs) to ensure high-quality performance and accuracy.
          </li>
          <li>
            <strong>Easy Integration:</strong> Our modular AI agents come with straightforward APIs and thorough documentation, making it simple to connect them to your existing software stack.
          </li>
        </ol>
        <h3>Features & Benefits</h3>
        <ul>
          <li><strong>User-Friendly Dashboard:</strong> Manage your subscriptions, monitor usage metrics, and fine-tune performance settings—all in one centralized dashboard.</li>
          <li><strong>Scalable Architecture:</strong> Start with a single AI agent and expand your subscription as your business demands grow.</li>
          <li><strong>Continuous Updates & Support:</strong> With each subscription, you receive ongoing updates that keep your AI agent aligned with the latest algorithmic improvements, along with dedicated support.</li>
        </ul>
        <h3>How to Get Started</h3>
        <ol>
          <li><strong>Browse Our Catalog:</strong> Explore a wide range of available AI agents, with detailed feature breakdowns and sample use-cases.</li>
          <li><strong>Subscribe & Integrate:</strong> Select your subscription plan and follow our quick integration guide.</li>
          <li><strong>Activate & Optimize:</strong> Your new AI agent will be up and running in minutes. Customize it further with your own data to maximize ROI.</li>
        </ol>
      </section>
    </div>
  );
}

export default ModularB2B;
